<app-modal>
  <app-modal-header [title]="headerText" [showDelete]="showDelete" (closed)="onClose()"> </app-modal-header>

  <app-modal-body>
    <ng-container *ngIf="!loading; else loadingState">
      <div class="right-pane-wrapper pane-wrapper custom-scrollbar">
        <ng-template #letterSections let-symbols="symbols">
          <div class="letter-sections-wrapper custom-scrollbar">
            <div class="checkpoint-count-wrapper">
              {{ T.common.count_selected.many | translate: { count: selectedGroups?.length } }},
              {{ T.common.count_total | translate: { count: groups?.length } }}
            </div>
            <div *ngFor="let symbol of symbols" class="letter-section">
              <div class="letter-heading">{{ symbol }}</div>
              <div
                *ngFor="let group of groupsBySymbol[symbol]"
                class="letter-section-item"
                (click)="onChecked(group, !groupsSelected[group.id])"
              >
                <app-checkbox
                  [isChecked]="groupsSelected[group.id]"
                  (checked)="onChecked(group, !groupsSelected[group.id])"
                ></app-checkbox>
                <div class="letter-section-item-text">{{ group.title }}</div>
              </div>
            </div>
          </div>
        </ng-template>
        <div class="schedule-peap-right-section-header">
          <div class="search-peaps-wrapper">
            <app-list-header
              [searchPlaceholder]="T.common.search_item | translate: { item: localisedGroups }"
              (onSearch)="onSearch($event)"
              [showRAGBreakdown]="false"
            >
            </app-list-header>
          </div>
        </div>
        <div class="letter-template-section" style="margin-top: 12px">
          <ng-template
            [ngTemplateOutlet]="letterSections"
            [ngTemplateOutletContext]="{
              symbols: symbols,
              employeesBySymbol: groupsBySymbol
            }"
          ></ng-template>
        </div>
      </div>
    </ng-container>
    <ng-template #loadingState>
      <app-skeleton-card-loading [showListHeader]="false" [largeCards]="false" [count]="5"> </app-skeleton-card-loading>
    </ng-template>
  </app-modal-body>
  <app-modal-footer>
    <div class="action-buttons">
      <app-button-rectangle
        class="button"
        [buttonTheme]="'white'"
        [size]="'large'"
        [text]="T.common.cancel | translate"
        (clicked)="onClose()"
      ></app-button-rectangle>
      <app-button-rectangle
        class="button"
        [buttonTheme]="'primary'"
        [size]="'large'"
        [text]="T.common.save | translate"
        (clicked)="onSaveAndExit()"
      ></app-button-rectangle>
    </div>
  </app-modal-footer>
</app-modal>
